module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2l"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "ch03"
    }
  }, [_vm._v("AND THEN")])]), _c('a', {
    attrs: {
      "id": "ch03"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Tuesday, August 1, 2006, 7:25 a.m.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I can’t breathe,” she whispers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His hot fingers lace her ribs, sear through her skin to her frozen lungs. He holds her. Kisses her. Breathes for her. Through her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Makes her forget.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Afterward, he says, “We’re going. Right now. Come.”")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("She does it.")])]), _c('p', {
    staticClass: "indenta"
  }, [_c('a', {
    attrs: {
      "id": "ch03"
    }
  }, [_vm._v("On the three-hour drive, she looks through eyelashes at her blurred fingers, curled in her lap. Pretends to be ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("asleep. Not sure why. Just soaking in the quiet. And knowing, deep down.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Knowing that he,")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("and this,")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("are not answers to her problems.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("She’s beginning to realize what is.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c1b682c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 81
// module chunks = 0